import { CAMPAIGN_FORM_TITLE } from '~/constants/campaign'
import { CampaignCostHandlingMethod, CampaignCategory } from '~/generated/graphql'

export const getSponsorServicePriceTitle = (
  costHandlingMethod: CampaignCostHandlingMethod,
  category: CampaignCategory,
): string => {
  if (costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign) {
    return CAMPAIGN_FORM_TITLE.sponsorServicePriceExpense
  }

  if (category === CampaignCategory.Service) {
    return CAMPAIGN_FORM_TITLE.sponsorServicePriceStore
  }

  return CAMPAIGN_FORM_TITLE.sponsorServicePriceProduct
}

export const getUrlTitle = (costHandlingMethod: CampaignCostHandlingMethod, category: CampaignCategory): string => {
  if (costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign) {
    return CAMPAIGN_FORM_TITLE.urlExpense
  }

  return category === CampaignCategory.Service ? CAMPAIGN_FORM_TITLE.urlStore : CAMPAIGN_FORM_TITLE.urlProduct
}

export const getMaxCompanionCountTitle = (costHandlingMethod: CampaignCostHandlingMethod): string => {
  return costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign
    ? CAMPAIGN_FORM_TITLE.maxCompanionCountExpense
    : CAMPAIGN_FORM_TITLE.maxCompanionCount
}
